import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((_theme) => ({
  previewImage: {
    maxHeight: 500,
  },
}));
